<template>
  <main style="--theme:#fab437">
    <!-- hero -->
    <section class="bg-black relative">
      <base-video v-bind="hero.video" />
      <div class="flex items-end absolute-0 justify-center z-1">
        <vf-button class="mb-18" to="#events" variant="primary-inverse">
          {{ hero.eventsCta }}
        </vf-button>
      </div>
      <custom-arrow-scroll
        class="c-white mb-10 ml-10 mr-4 bottom-0 absolute z-2 <md:right-0 md:left-0"
        :size="{ sm: 'sm', md: 'md' }"
        to="#discover"
      />
    </section>
    <section id="discover" class="bg-black">
      <h1
        class="c-white fw-light text-center"
        style="font-size: clamp(0px,5vw,4.5rem); padding: clamp(0px,4.86vw,4.38rem)"
      >
        {{ hero.title }}
      </h1>
    </section>
    <section class="text-sm md:flex">
      <div
        v-style:p="{
          sm: '10.66vw',
          md: 'clamp(0px,4.16vw,3.75rem) clamp(0px,8.33vw,7.5rem) clamp(0px,4.16vw,3.75rem) clamp(0px,16.66vw,15rem)',
        }"
        class="f-col justify-center relative md:w-2/3"
        style="background: #dadada"
      >
        <base-picture
          v-style:w="{ sm: '22.66vw', md: 'clamp(0px,8.33vw,7.5rem)' }"
          v-bind="discover.logo"
          style="filter: brightness(0)"
        />
        <p v-style:text-size="{ sm: '4.26vw', md: 'clamp(0px,1.11vw,1rem)' }" class="lh-tight my-4">
          {{ discover.text }}
        </p>
        <vf-button class="self-start" to="#events" variant="themable">
          {{ discover.cta }}
        </vf-button>
        <custom-arrow-scroll
          class="mb-4 ml-10 mr-4 bottom-0 absolute <md:right-0 md:left-0"
          :size="{ sm: 'sm', md: 'md' }"
          to="#events"
        />
      </div>
      <div
        v-if="enableLoyaltyFeatures"
        v-style:p="{
          sm: '10.66vw',
          md: 'clamp(0px,4.16vw,3.75rem) clamp(0px,5.5vw,5rem) clamp(0px,4.16vw,3.75rem) clamp(0px,8.33vw,7.5rem)',
        }"
        class="md:w-1/3"
        style="background: #c6c6c6"
      >
        <base-picture v-style:w="{ sm: '40vw', md: 'clamp(0px,9.38vw,8.43rem)' }" v-bind="signup.logo" />
        <p v-style:text-size="{ sm: '4.26vw', md: 'clamp(0px,1.11vw,1rem)' }" class="lh-tight my-4">
          {{ signup.text }}
        </p>
        <vf-button
          v-if="!auth.loggedIn"
          @click="DialogSignUp.open({
            formLocation: 'modal:single:body:none',
          })"
        >
          {{ signup.cta }}
        </vf-button>
        <vf-button v-else to="#events">
          {{ signup.cta2 }}
        </vf-button>
      </div>
      <div v-else class="md:w-1/3">
        <base-picture class="full" fit="cover" v-bind="signup.image" />
      </div>
    </section>
    <section id="events">
      <div v-if="sectionData" v-style:p="{ sm: '16vw 10.67vw 0', md: '6vw 1.25rem 0' }" class="container">
        <div class="md:text-center">
          <base-picture v-style:w="{ sm: '100%', md: 'clamp(0px,38.19vw,34.36rem)' }" v-bind="basecampImg" />
          <h2 v-style:text-size="subTitleTextSize">
            {{ events.title }}
          </h2>
        </div>
        <cms-section v-if="sections?.events" lazy-media :section="sections.events" />
      </div>
    </section>
    <section v-style:p="{ sm: '16vw 10.67vw', md: '6vw 0' }" class="md:text-center">
      <base-picture v-style:w="{ sm: '100%', md: 'clamp(0px,38.19vw,34.36rem)' }" v-bind="basecampImg" />
      <h2 v-style:text-size="subTitleTextSize">
        {{ locations.title }}
      </h2>
    </section>
    <section>
      <base-picture class="md:mb-3" v-bind="locations.image" />
      <div class="relative">
        <base-picture v-bind="locations.map.image" />
        <span class="right-0 top-0" :class="countryTitleClasses" :style="countryTitleStyles">
          {{ $t.countries.DE }}
        </span>
        <span class="bottom-0 right-0" :class="countryTitleClasses" :style="countryTitleStyles">
          {{ $t.countries.IT }}
        </span>
        <span
          class="rotate-180 bottom-0 top-0 write-vertical-left"
          :class="countryTitleClasses"
          :style="countryTitleStyles"
        >
          {{ $t.countries.FR }}
        </span>
        <base-button
          v-for="({ position, modal, pulseInset, graphic }, key) in locations.map.hotspots"
          :key
          v-style:inset="{
            sm: `${position.top.sm} auto auto ${position.left.sm}`,
            md: `${position.top.md} auto auto ${position.left.md}`,
          }"
          class="flex items-end absolute"
          @click="activeLocation = modal"
        >
          <div v-style:inset="{ sm: `${pulseInset}`, md: 'auto auto auto -10%' }" class="h-5 w-5 absolute">
            <div class="animation-pulsate rounded-full bg-$theme full left-1/2 top-1/2 absolute" />
            <div class="rounded-full bg-$theme full absolute" />
            <div
              class="rounded-full bg-white left-1/2 top-1/2 absolute"
              style="transform: translate(-50%, -50%); width: 0.25rem; height: 0.25rem"
            />
          </div>
          <base-picture
            v-style:w="{ sm: '34.67vw', md: 'clamp(0px,14.58vw,13.13rem)' }"
            class="md:ml-4"
            :src="graphic"
          />
        </base-button>
      </div>
    </section>
    <section v-style:p="{ sm: '16vw 10.67vw 15vw', md: '6vw 0 5vw' }" class="md:text-center">
      <base-picture v-style:w="{ sm: '100%', md: 'clamp(0px,38.19vw,34.36rem)' }" v-bind="basecampImg" />
      <p v-style:text-size="{ sm: '4.27vw', md: 'clamp(0px,1.11vw,1rem)' }" class="c-black lh-tight uppercase">
        {{ film.title }}
      </p>
    </section>
    <section class="group relative">
      <base-picture
        class="w-full overflow-hidden"
        :props-img="{ class: 'duration scale-105 group-hover:scale-100' }"
        v-bind="film.thumbnail"
      />
      <base-button
        class="flex center absolute-0"
        @click="ModalYoutube.open({ videoUrl: film.src, title: film.text })"
      >
        <vf-icon class="c-white duration group-hover:scale-120" name="play" size="4xl" />
      </base-button>
    </section>
    <transition name="nested">
      <vf-modal
        v-if="activeLocation"
        class-content="w-full md:w-1/2 !p-0 !bg-transparent"
        size="lg"
        @resolve="activeLocation = undefined"
      >
        <base-picture v-bind="activeLocation.img" />
        <div
          v-style="{
            p: {
              sm: '10.67vw 10.67vw 21.33vw',
              md: 'clamp(0px,6.94vw,6.25rem) 0 0 clamp(0px,9.72vw,8.75rem)',
            },
            w: {
              sm: '87.5%',
              md: '75%',
            },
          }"
          class="c-black lh-tight absolute-0"
        >
          <h3 v-style:text-size="{ sm: '6.4vw', md: 'clamp(0px,2.36vw,2.125rem)' }" class="fw-medium mb-3">
            {{ activeLocation.title }}
          </h3>
          <p v-style:text-size="{ sm: '4.27vw', md: 'clamp(0px,1.11vw,1rem)' }">
            {{ activeLocation.text }}
          </p>
        </div>
        <base-picture class="mb-2 mr-2 mt-14 inset-y-0 right-0 absolute" :src="activeLocation.titleImg" />
      </vf-modal>
    </transition>
    <modal-youtube class-content="bg-transparent shadow-transparent" hide-close-button size="md" />
  </main>
</template>

<script lang="ts" setup>
definePageMeta({ header: { transparent: true } })

const { $t } = useNuxtApp()
const { data, error } = await useApi().internal.getStaticPage('basecamp')
const { data: sectionData } = await useCms().getSections.basecamp()
const sections = sectionData.value?.content.sectionsMap

if (!data.value) throw createError({ ...error.value!, fatal: true })

const { basecampImg, events, hero, discover, signup, locations, film } = data.value

const { enableLoyaltyFeatures } = useFeatureFlags()

const auth = useAuthStore()
const { DialogSignUp } = useDialogsStore()
const ModalYoutube = createModal('youtube')

const activeLocation = ref()

const subTitleTextSize = { sm: '4.27vw', md: 'clamp(0px,1.11vw,1rem)' }

const countryTitleClasses = 'fw-light absolute left-0 text-center <md:hidden'
const countryTitleStyles = 'font-size: 4.17vw; color: #a0a0a066'

useSeoMeta({
  ogType: 'article',
  // TODO: Add ogImage
  ogImage: null,
})
</script>
